export default "__VITE_ASSET__BvP63ehK__"